module.exports = __webpack_public_path__ + "assets/img/09a910f29a982721bf1b08f3af56e118.svg";